<template>
  <nav>
    <a @click="$emit('selectTag', tag)" v-for="tag in filter(tags)" :id='tagID(tag)' :class='{select: select == tag }' :key='tag' v-html='tag' />
  </nav>
</template>

<style scoped>
  nav {
    display: flex;
    flex-wrap: wrap;
    gap: 0.4em;
    margin-bottom: 2em;
  }
  a {
    padding: 0.3em;
    border-radius: 2em;
    display: inline-block;
    background-color: var(--mint);
    background-color: #cae6e5;
    font-size: 0.9rem;
    padding: 0.5em 1.5em;
    border-radius: 1em;
    line-height: 1em;
    cursor: pointer;
    user-select: none;
  }
  a.select {
    background-color: var(--blue) !important;
    color: white;
  }
</style>

<script>
export default {
  props: ['tags', 'filtered', 'select'],
  methods: {
    tagID(tag) {
      return tag.replaceAll(' ','-') + '-Tag';
    },
    filter: function(tags) {
      let self = this;
      tags = tags.filter(function(element) {
        return self.filtered ? self.filtered.indexOf( element ) < 0 : true;
      });
      return tags;
    }
  }
}
</script>
